import { MONTHS, MONTHS_SHORT } from "../data/constants";

export default function CalendarHeader({ mobile, currentMonth, currentYear, onPrev, onNext, onToday, onCreate }) {
  return (
    <div className="ec-header">
      <div className="ec-header-left">
        <div className="ec-header-nav">
          <button onClick={onPrev} className="ec-nav-btn">‹</button>
          <button onClick={onNext} className="ec-nav-btn">›</button>
        </div>

        <h1 className="ec-header-title">
          {mobile ? MONTHS_SHORT[currentMonth] : MONTHS[currentMonth]}{" "}
          <span className="ec-header-title-year">{currentYear}</span>
        </h1>

        <button onClick={onToday} className="ec-today-btn">Hoy</button>
      </div>

      <button onClick={onCreate} className="ec-create-btn">
        <span className="ec-create-btn-icon">+</span>
        {mobile ? "Nuevo" : "Crear evento"}
      </button>
    </div>
  );
}
